import React from 'react'
import PropTypes from 'prop-types'
import styled, { css, keyframes } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Link from 'components/common/Link/Link'
import Icon from 'components/common/Icon/Icon'
import Button from 'components/common/Button/Button'
import Media from 'components/common/Media'
import { CALL_STORE_FOR_PRICE_FIRST_TEXT } from 'constant'
import PhoneLink from 'components/common/PhoneLink'
import SaveForLaterQuantityInput from '../SaveForLaterQuantityInput'
import FavoriteButton from 'components/MyFavorites/FavoriteButton'

const SaveForLaterItem = ({
  product: {
    imageUrl,
    logoUrl,
    brandName,
    tireLineName,
    tireSize,
    skuId,
    listPrice,
    tireDetailUrl
  },
  handleRemoveItem,
  handleAddToQuote,
  handleQuantityChange,
  handleProductClick,
  isShowCallStoreForPrice,
  storePhoneNumber,
  tireQuantity,
  itemState
}) =>
  <ProductItem id={ `item-container${skuId}` } isAnimating={ itemState }>
    <div>
      <BrandLogo alt={ brandName } data-at-quote-product-logo src={ logoUrl } />

      <FavoriteButtonHeart
        countFront={ tireQuantity }
        skuId={ skuId }
        tireLineName={ tireLineName }
        imageUrl={ imageUrl }
        brandLogoUrl={ logoUrl }
        frontTireSize={ tireSize } />

      <ProductInfo>
        <ImageWrapper>
          <ProductImage
            alt={ tireLineName }
            data-at-quote-product-image
            src={ `${imageUrl}?$BOT-TireSearchResult-Tire-Desktop-w180-h180$` } />
        </ImageWrapper>

        <ProductDetails>
          <ProductLink to={ tireDetailUrl } onClick={ handleProductClick } >
            { tireLineName }
          </ProductLink>

          <Size>
            { tireSize }
          </Size>

          {isShowCallStoreForPrice
            ? (
              <>
                <Media.Desktop>
                  <ProductPriceWrapper><Price>{ CALL_STORE_FOR_PRICE_FIRST_TEXT }</Price></ProductPriceWrapper>
                </Media.Desktop>
                <Media.Mobile>
                  <ProductPriceWrapper>
                    <CallForPriceLink number={ storePhoneNumber }>
                      { CALL_STORE_FOR_PRICE_FIRST_TEXT }
                    </CallForPriceLink>
                  </ProductPriceWrapper>
                </Media.Mobile>
              </>
            )
            : (
              <ProductPriceWrapper>
                <Price>{`$${listPrice} `}</Price>
                /each
              </ProductPriceWrapper>
            )}

          <TireQuantity
            extraSmall
            minValue={ 1 }
            value={ tireQuantity }
            id={ skuId }
            onChange={ handleQuantityChange } />
        </ProductDetails>
      </ProductInfo>
      <Button
        stacked
        narrow
        full
        onClick={ handleAddToQuote }>Add to quote  </Button>
    </div>
    <CloseButton onClick={ handleRemoveItem }>
      <CloseIcon alt={ `Remove ${tireLineName} from the Save for later list` } asset="menu-close" />
    </CloseButton>
  </ProductItem>

SaveForLaterItem.propTypes = {
  handleAddToQuote: PropTypes.func,
  handleProductClick: PropTypes.func,
  handleQuantityChange: PropTypes.func,
  handleRemoveItem: PropTypes.func,
  isShowCallStoreForPrice: PropTypes.bool,
  itemState: PropTypes.string,
  product: PropTypes.shape({
    imageUrl: PropTypes.string,
    logoUrl: PropTypes.string,
    brandName: PropTypes.string,
    tireLineName: PropTypes.string,
    tireSize: PropTypes.string,
    quantity: PropTypes.number,
    skuId: PropTypes.string,
    listPrice: PropTypes.number,
    tireDetailUrl: PropTypes.string
  }),
  storePhoneNumber: PropTypes.string,
  tireQuantity: PropTypes.number
}

export default SaveForLaterItem

const fadeOut = keyframes`
  0% {
    opacity: 1;
    transform: translateX(0);
  }

  100% {
    opacity: 0;
    transform: translateX(-100%);
  }
`

const ProductItem = styled.div`
  position: relative;
  height: 236px;
  padding: 18px 15px 25px 16px;
  margin: 0 21px;
  background-color: ${Theme.colors.white};
  ${props => props.isAnimating && css`
    animation: 0.5s ${fadeOut} ease-out;
  `}

  @media (max-width: 1279px) {
    margin: 0 10px;
  }
`

const FavoriteButtonHeart = styled(FavoriteButton)`
  position: absolute;
  top: 45px;
  left: 80px;

  && img {
    display: inline;
  }
`

const BrandLogo = styled.img`
  position: absolute;
  top: 20px;
  max-width: 180px;
  max-height: 25px;
  margin: 0 0 19px 0;
`

const ImageWrapper = styled.div`
  display: flex;
  overflow: hidden;
  max-width: 96px;
  width: 100%;
  height: 102px;
  margin: 0 10px 0 0;
`

const ProductImage = styled.img``

const ProductInfo = styled.div`
  display: flex;
  width: 100%;
  margin: 45px 0 15px 0;
`

const ProductDetails = styled.div`
  width: 100%;
`

const TireQuantity = styled(SaveForLaterQuantityInput)`
  width: auto;
`

const ProductLink = styled(Link)`
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-line-clamp: 1;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0 0 15px 0;
  font-size: 12px;
`

const Size = styled.div`
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-line-clamp: 1;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 15px;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
`

const ProductPriceWrapper = styled.div`
  font-size: 12px;
  line-height: 14px;
  margin: 0 0 10px 0;
`

const Price = styled.span`
  font-size: 12px;
  font-weight: 700;
`

const CallForPriceLink = styled(PhoneLink)`
  font-size: 12px;
`

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 15px;
  padding: 0;
  border-radius: 50%;
  background: none;
  cursor: pointer;
  border: none;
`

const CloseIcon = styled(Icon)`
  width: 10px;
  height: 10px;
`
